import angular from 'angular';

import './trade-ins.styles.scss';

import TradeInsController from './trade-ins.controller';
import TradeInRoutes from './trade-ins.routes';

export default angular.module('autoboard.tradeInsTable', [])
  .controller('TradeInsController', TradeInsController)
  .config(TradeInRoutes)
  .name;
